package com.example.positionahead.model

data class PlanCompareOption(
    val id: String,
    val title: String,
    val subtitle: String,
    val summary: PortfolioSummary,
    val whyDifferent: String,
)

data class PlanPositionDiff(
    val symbol: String,
    val currentMarketValue: Double,
    val alternativeMarketValue: Double,
    val deltaDollars: Double,
    val currentWeightPercent: Double,
    val alternativeWeightPercent: Double,
    val explanation: String,
)
